import React from "react"
import {
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,Link,
    useDisclosure,Button
  } from '@chakra-ui/react'
  import {BsThreeDotsVertical} from "react-icons/bs";
  import { themeContext } from "../context/Context";
  import { useContext } from "react";



function Drawers() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [placement, setPlacement] = React.useState('left')
    let theme = useContext(themeContext);
  let darkmode = theme.state.darkMode;
  
    return (
      <div>
        {/* <RadioGroup defaultValue={placement} onChange={setPlacement}> */}
          {/* <Stack direction='row' mb='4'>
            <Radio value='top'>Top</Radio>
            <Radio value='right'>Right</Radio>
            <Radio value='bottom'>Bottom</Radio>
            <Radio value='left'>Left</Radio>
          </Stack> */}
        {/* </RadioGroup> */}
        <Button colorScheme='orangered' onClick={onOpen}>
          <BsThreeDotsVertical color={darkmode?"white":"black"}/>
        </Button>
        <Drawer placement={placement} onClose={onClose} isOpen={isOpen}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader borderBottomWidth='1px' bg="orangered" color="white">Go To </DrawerHeader>
            <DrawerBody bg={darkmode?"rgb(54, 53, 53)": "rgb(217, 235, 252)"} color={darkmode?"white":"black"} border="3px solid orangered">
             <Link spy={true}
                to="Navbar"
                smooth={true}
                activeClass="activeClass"><p>Home</p></Link>
              <Link spy={true}
                to="Navbar"
                smooth={true}
                activeClass="activeClass"><p>About Me</p></Link>
              <Link spy={true}
                to="project"
                smooth={true}
                activeClass="activeClass"><p>Projects</p></Link>
              <Link spy={true}
                to="skill"
                smooth={true}
                activeClass="activeClass"><p>Skills</p></Link>
              <Link spy={true}
                to="contact"
                smooth={true}
                activeClass="activeClass"><p>Contact</p></Link>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </div>
    )
  }
  export default Drawers
